// Mock data for BioSpectrix website

export const products = [
  {
    id: 1,
    name: "Food Freeze Dryers",
    category: "Freeze Drying",
    description: "Advanced lyophilization technology for food preservation, pharmaceutical applications, and research. Maintains nutritional value and extends shelf life.",
    image: "https://customer-assets.emergentagent.com/job_flamboyant-sanderson-7/artifacts/m3zv04a7_BioSpectrix%20Food%20Freeze%20Dryer%20Pic.png",
    features: [
      "Capacity: 4kg to 500kg+",
      "Multiple tray configurations",
      "Fully Automatic & Intelligent machine",
      "Automated control system",
      "Energy efficient design"
    ],
    applications: ["Food Industry", "Pharmaceuticals", "Biotechnology", "Research Labs"]
  },
  {
    id: 2,
    name: "Laboratory Centrifuges",
    category: "Separation",
    description: "High-performance centrifuges for precise sample separation. Designed for clinical, research, and industrial laboratories with advanced safety features.",
    image: "https://images.unsplash.com/photo-1707944745824-c038557dfd7c",
    features: [
      "Speed range: 200 - 25,000 RPM",
      "Temperature control: -20°C to +40°C, Refrigerated & non refrigerated",
      "Multiple rotor options",
      "Digital display & controls",
      "Automatic lid lock safety"
    ],
    applications: ["Clinical Labs", "Blood Banking", "Microbiology", "Molecular Biology"]
  },
  {
    id: 3,
    name: "Laboratory Incubators",
    category: "Environmental Control",
    description: "Precision incubators for cell culture, bacterial growth, and controlled environment studies. Uniform temperature distribution and stability.",
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69",
    features: [
      "Temperature range: +5°C to +80°C",
      "±0.1°C temperature accuracy",
      "Humidity control option",
      "CO2 control for cell culture",
      "HEPA filtration available"
    ],
    applications: ["Cell Culture", "Microbiology", "Pharmaceutical", "Quality Control"]
  }
];

export const services = [
  {
    id: 1,
    icon: "Settings",
    title: "Custom Manufacturing",
    description: "Tailored solutions designed to meet your specific laboratory requirements and workflow needs."
  },
  {
    id: 2,
    icon: "Wrench",
    title: "Installation & Calibration",
    description: "Professional on-site installation and precise calibration services by certified technicians."
  },
  {
    id: 3,
    icon: "Shield",
    title: "Warranty & Support",
    description: "Comprehensive warranty coverage with 24/7 technical support and rapid response times."
  },
  {
    id: 4,
    icon: "RefreshCw",
    title: "Maintenance Services",
    description: "Regular preventive maintenance and repair services to ensure optimal equipment performance."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Dr. Rajesh Kumar",
    position: "Head of Research, PharmaTech Industries",
    company: "PharmaTech Industries",
    content: "BioSpectrix's freeze dryers have revolutionized our pharmaceutical research. The precision and reliability are unmatched. Their technical support team is always responsive and knowledgeable.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1614935151651-0bea6508db6b"
  },
  {
    id: 2,
    name: "Prof. Anita Sharma",
    position: "Laboratory Director, National Research Institute",
    company: "National Research Institute",
    content: "We've been using BioSpectrix centrifuges for over 5 years. The build quality and consistent performance have made them an integral part of our daily operations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1562789278-dac7af7fb5b1"
  },
  {
    id: 3,
    name: "Mr. Vikram Patel",
    position: "Quality Control Manager, FoodTech Solutions",
    company: "FoodTech Solutions",
    content: "The incubators from BioSpectrix provide exceptional temperature stability. Their after-sales service and maintenance support are excellent.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1631556759511-6ce895fbf0ad"
  }
];

export const stats = [
  { label: "Years of Excellence", value: "15+" },
  { label: "Products Installed", value: "500+" },
  { label: "Happy Clients", value: "200+" },
  { label: "Countries Served", value: "12+" }
];

export const contactInfo = {
  email: "sales@biospectrix.co",
  address: "First Floor no 906, MD Property 1, old, 3rd Cross Rd, MRCR Layout, Govindaraja Nagar, Vijayanagar, Bengaluru, Karnataka 560040"
};
